import { Button } from 'antd';
import { strings } from '../../lang';
import { useState, memo } from 'react';
import { ArrowLeftOutlined } from '@ant-design/icons';

const classMap: Record<string, string> = {
  BronzeButton: 'customizable-btn btn-grad-bronze btn-grad-bronze:hover',
  SilverButton: 'customizable-btn btn-grad-silver btn-grad-silver:hover',
  GoldButton: 'customizable-btn btn-grad-gold btn-grad-gold:hover',
  SpaceButton: 'customizable-btn btn-grad-space btn-grad-space:hover',
};

type Props = {
  buttonStyle: string | undefined;
  onClick: () => void;
  disabled?: boolean;
};

type BackButtonProps = {
  onClick: () => void;
  style?: React.CSSProperties;
};

export const StartBookingButton: React.FC<Props> = memo(({ buttonStyle, onClick }) => {
  const [className] = useState(classMap[buttonStyle ?? '']);

  if (className) {
    return (
      <button className={className} onClick={onClick}>
        {strings.startBooking}
      </button>
    );
  }

  return (
    <Button type="primary" onClick={onClick}>
      {strings.startBooking}
    </Button>
  );
});

export const LoadCalendarButton: React.FC<Props> = memo(({ buttonStyle, onClick, disabled }) => {
  const [className] = useState(classMap[buttonStyle ?? '']);

  if (className) {
    return (
      <button className={className} onClick={onClick} disabled={disabled}>
        {strings.loadCalendar}
      </button>
    );
  }

  return (
    <Button type="primary" onClick={onClick} disabled={disabled}>
      {strings.loadCalendar}
    </Button>
  );
});

export const CalendarBackButton: React.FC<BackButtonProps> = ({ onClick, style }) => {
  return (
    <Button type="text" style={{ fontWeight: 'bold', marginTop: '16px', ...style }} icon={<ArrowLeftOutlined />} onClick={onClick}>
      {strings.back}
    </Button>
  );
};
